<!-- 添加游戏遮罩层 -->
<template>
    <div class="other-browser" v-show="show">
        <div class="arrow bgs100"></div>
        <div class="yellow p1">点击右上角分享按钮，</div>
        <div class="yellow p1">选择【在浏览器中打开】</div>
        <div class="p2">
            <span>1.点击右上角的</span>
            <div class="more bgs100"></div>
        </div>
        <div class="line bgs100"></div>
        <div class="p2">
            <span>2.选择在浏览器中打开</span>
            <div class="browser-icon bgs100"></div>
        </div>
        <!-- <div class="line bgs100"></div>
        <div class="p2">
            <span>3.点击下载</span>
        </div> -->
    </div>
</template>

<script>
import { getBgImg } from '@/common/js/util';
export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: () => {}
        }
    },
    data () {
        return {
        }
    },
    methods: {
        getBgImg(src) {
            return getBgImg(src);
        },
        closeAll() {
            sessionStorage.setItem('gameId'+this.data.game_id+'noPromote', '1');
            this.$emit('close');
        },
    }
}
</script>

<style lang='scss' scoped>
    .other-browser {
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.7);
        top: 0;
        z-index: 99;
        padding-top: 1.73rem;
        padding-left: 1.19rem;
        .arrow {
            width: 1.07rem;
            height: 1.59rem;
            background-image: url('./../assets/share/arrow@2x.png');
            position: absolute;
            top: 0.35rem;
            right: 0.23rem; 
        }
        .yellow.p1 {
            font-size: 0.18rem;
            font-family: PingFang SC;
            font-weight: 500;
            color: #F7E970;
            line-height: 0.26rem;
        }
        .yellow.p1:nth-child(3) {
            margin-bottom: 0.21rem;
        }
        .p2 {
            display: flex;
            align-items: center;
            span {
                font-size: 0.18rem;
                font-family: PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
            }
            .more {
                margin-left: 0.08rem;
                width: 0.21rem;
                height: 0.05rem;
                background-image: url('./../assets/share/more@2x.png');
                position: relative;
                top: 0.01rem;
            }
            .browser-icon {
                width: 0.21rem;
                height: 0.21rem;
                margin-left: 0.06rem;
                background-image: url('./../assets/share/browser@2x.png');
                position: relative;
                top: 0.01rem;
            }
        }
        .line {
            width: 0.01rem;
            height: 0.21rem;
            background-image: url('./../assets/share/line@2x.png');
            margin: 0.06rem 0 0.06rem 0.07rem;
        }
    }
</style>
